<template>
<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 480.182 480.182" style="enable-background:new 0 0 480.182 480.182;" xml:space="preserve">
<g>
	<g>
		<path d="M200.182,32.106c-92.784,0-168,75.216-168,168s75.216,168,168,168s168-75.216,168-168
			C368.081,107.364,292.924,32.207,200.182,32.106z M200.182,48.106c49.416,0.039,95.723,24.123,124.128,64.56l-20,20
			c-4.867-2.945-10.439-4.521-16.128-4.56c-17.673,0-32,14.327-32,32c0.028,5.695,1.595,11.276,4.536,16.152l-52.384,52.384
			c-9.919-6.048-22.385-6.048-32.304,0l-36.384-36.384c2.941-4.876,4.508-10.457,4.536-16.152
			c0.022-17.638-14.258-31.954-31.896-31.976c-14.587-0.018-27.332,9.849-30.968,23.976h-29.68
			C66.785,98.159,128.614,48.211,200.182,48.106z M304.182,160.106c0,8.837-7.163,16-16,16s-16-7.163-16-16s7.163-16,16-16
			S304.182,151.269,304.182,160.106z M208.182,256.106c0,8.837-7.163,16-16,16s-16-7.163-16-16c0-8.837,7.163-16,16-16
			S208.182,247.269,208.182,256.106z M128.182,176.106c0,8.837-7.163,16-16,16s-16-7.163-16-16s7.163-16,16-16
			S128.182,167.269,128.182,176.106z M274.036,333.012c-22.592,12.544-48.012,19.116-73.854,19.093
			c-83.89,0.057-151.943-67.902-152-151.792c-0.004-5.414,0.282-10.825,0.856-16.208h32.28c3.637,14.085,16.317,23.945,30.864,24
			c5.695-0.028,11.276-1.595,16.152-4.536l36.384,36.384c-2.941,4.876-4.508,10.457-4.536,16.152c0,17.673,14.327,32,32,32
			s32-14.327,32-32c-0.028-5.695-1.595-11.276-4.536-16.152l52.384-52.384c4.876,2.941,10.457,4.508,16.152,4.536
			c17.673,0,32-14.327,32-32c-0.028-5.695-1.595-11.276-4.536-16.152l17.44-17.432C373.801,199.849,347.363,292.298,274.036,333.012
			z"/>
	</g>
</g>
<g>
	<g>
		<path d="M400.182,80.106c14.547-0.055,27.227-9.914,30.864-24h49.136v-16h-49.136c-3.637-14.086-16.317-23.945-30.864-24
			c-17.673,0-32,14.327-32,32c0.028,5.695,1.595,11.276,4.536,16.152l-14.056,14.056C291.407-9.307,165.855-25.817,78.234,41.438
			S-25.897,234.246,41.358,321.867c63.484,82.707,179.855,102.77,267.368,46.095l24.144,24.144l11.312,11.312l64.4,64.4
			c16.379,16.379,42.933,16.379,59.312,0c16.379-16.379,16.379-42.933,0-59.312l-64.4-64.4l-11.312-11.312l-24.144-24.144
			c42.859-66.016,42.859-151.071,0-217.088l16-16C388.911,78.504,394.49,80.074,400.182,80.106z M400.182,32.106
			c8.837,0,16,7.163,16,16s-7.163,16-16,16s-16-7.163-16-16S391.346,32.106,400.182,32.106z M456.582,419.818
			c10.246,10.016,10.433,26.442,0.417,36.688c-10.016,10.246-26.442,10.433-36.688,0.417c-0.141-0.137-0.279-0.276-0.417-0.417
			l-64.4-64.4l36.688-36.688L456.582,419.818z M380.87,344.106l-36.688,36.688l-22.144-22.144c1.128-0.864,2.184-1.816,3.296-2.704
			s2.4-1.952,3.592-2.952c1.752-1.472,3.48-2.96,5.176-4.488c0.872-0.8,1.704-1.6,2.56-2.4c3.28-3.072,6.456-6.248,9.528-9.528
			c0.8-0.856,1.6-1.688,2.4-2.56c1.528-1.696,3.016-3.424,4.488-5.176c1.003-1.184,1.987-2.381,2.952-3.592
			c0.88-1.104,1.832-2.16,2.696-3.288L380.87,344.106z M349.846,306.946c-2.52,3.52-5.12,6.968-7.864,10.288
			c-0.8,0.968-1.656,1.904-2.48,2.856c-2.448,2.848-4.976,5.611-7.584,8.288c-1.136,1.173-2.291,2.328-3.464,3.464
			c-2.667,2.608-5.429,5.136-8.288,7.584c-0.952,0.8-1.888,1.672-2.856,2.48c-3.32,2.744-6.768,5.344-10.288,7.864
			c-82.816,59.165-197.915,39.992-257.08-42.824S9.95,109.031,92.766,49.866S290.681,9.873,349.846,92.69
			C395.627,156.772,395.627,242.864,349.846,306.946z"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
</template>
